var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('h5',[_vm._v("Copyright © "+_vm._s(_vm.year)+" by PT Beo Teknologi Suara")])])}
var staticRenderFns = []

export { render, staticRenderFns }